import React, { useContext } from 'react';
import { CompanyContext } from '../../../../context/CompanyContext';
import { CompanyMutations, UpdateCompanyResponse, UpdateCompanyVariables } from '../../../../graphql/company.graphql';
import useMutation from '../../../../hooks/useMutation';
import { Company } from '../../../../types/company';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import AlertFeatureTogglesView from './Views/AlertFeatureTogglesView';
import AssetFeatureTogglesView from './Views/AssetFeatureTogglesView';
import CompanyFeatureTogglesView from './Views/CompanyFeatureTogglesView';
import ContainerFeatureTogglesView from './Views/ContainerFeatureTogglesView';
import LotFeatureTogglesView from './Views/LotFeatureTogglesView';
import OrderFeatureTogglesView from './Views/OrderFeatureTogglesView';
import ProductTransactionsFeatureTogglesView from './Views/ProductTransactionFeatureTogglesView';
import QuickActionFeatureTogglesView from './Views/QuickActionFeatureTogglesView';
import TaskFeatureTogglesView from './Views/TaskFeatureTogglesView';
import ScanFeatureTogglesView from './Views/ScanFeatureTogglesView';
import ProductFeatureTogglesView from './Views/ProductFeatureTogglesView';
import KitFeatureTogglesView from './Views/KitFeatureTogglesView';

export default function FeatureToggleSettingsScreen() {
  const { currentCompany, setCurrentCompany } = useContext(CompanyContext);

  const [update, { loading }] = useMutation<UpdateCompanyResponse, UpdateCompanyVariables>(CompanyMutations.update, {
    onCompleted: response => {
      setCurrentCompany(new Company(response.updateCompany));
    },
  });

  const handleUpdate = async (company: Company) => {
    if (loading) return;
    await update({ variables: { company: company.forUpdate() } });
  };

  return (
    <div className='content-y-screen content-x grid flex-grow items-center overflow-auto'>
      <div className='mx-auto grid max-w-[920px] gap-8'>
        <div className='grid gap-2'>
          <p className='page-title'>{t(TranslationKey.featureToggleSettingsScreenTitle).singular.upper}</p>
          <p className='subtitle'>{t(TranslationKey.featureToggleSettingsScreenSubtitle).singular.upper}</p>
        </div>

        <div className={`grid gap-4 pr-2`}>
          <OrderFeatureTogglesView company={currentCompany} update={handleUpdate} />
          <TaskFeatureTogglesView company={currentCompany} update={handleUpdate} />
          <AssetFeatureTogglesView company={currentCompany} update={handleUpdate} />
          <LotFeatureTogglesView company={currentCompany} update={handleUpdate} />
          <KitFeatureTogglesView company={currentCompany} update={handleUpdate} />
          <ProductTransactionsFeatureTogglesView company={currentCompany} update={handleUpdate} />
          <ProductFeatureTogglesView company={currentCompany} update={handleUpdate} />
          <ContainerFeatureTogglesView company={currentCompany} update={handleUpdate} />
          <CompanyFeatureTogglesView company={currentCompany} update={handleUpdate} />
          <QuickActionFeatureTogglesView company={currentCompany} update={handleUpdate} />
          <AlertFeatureTogglesView company={currentCompany} update={handleUpdate} />
          <ScanFeatureTogglesView company={currentCompany} update={handleUpdate} />
        </div>
      </div>
    </div>
  );
}
